import { ICookiesButtonWidgetData } from "@pageBuilder/typings";
import { WidgetRendererBase } from "../widget-renderer-base";
import { CookiesButtonScriptRenderer } from "./cookies-button-script-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";

export class CookiesButtonWidgetRenderer extends WidgetRendererBase<ICookiesButtonWidgetData> {

    private readonly scriptRenderer: CookiesButtonScriptRenderer;

    constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.scriptRenderer = new CookiesButtonScriptRenderer();
    }

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("cookiesButtonWidget");
    }

    protected override renderInternal(element: HTMLElement, data: ICookiesButtonWidgetData): HTMLElement {
        this.setAttributes(element, data);

        this.scriptRenderer.renderCommon(this.renderedDocument);
        this.scriptRenderer.renderLocal(element);

        return element;
    }

    private setAttributes(element: HTMLElement, data: ICookiesButtonWidgetData): void {
        element.toggleAttribute("data-primary-element", data.primaryElement);
        if (this.isEditorRendering) {
            element.setAttribute("data-draft", "true");
        }
    }

    protected override getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return [`#${element.id}`, `#${element.id} .button-element`, `#${element.id} .button-element:hover`, `#${element.id} .button-element:not(:hover)`, `#${element.id} .widget-content`];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override renderStyles(element: HTMLElement, data: ICookiesButtonWidgetData): void {
        throw new Error("Method not implemented.");
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override cleanupInternal(element: HTMLElement): void {
        // nothing
    }

}
